import React, { lazy } from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap, Rocket } from 'lucide-react';
export function MarcaPrivadaProduct() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/sistema-de-marca-privada%E2%84%A2', '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-beige pt-10 md:pt-14 pb-20 md:pb-24 px-5 sm:px-6 relative overflow-hidden" data-id="element-373">
      {/* Subtle background accents */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-374">
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-brand-gold/8 rounded-full blur-3xl" data-id="element-375"></div>
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-376"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-377">
        {/* Premium transition badge — bigger, more persuasive */}
        <FadeIn data-id="element-378">
          <div className="max-w-2xl mx-auto mb-10 md:mb-14" data-id="element-379">
            <div className="relative" data-id="element-380">
              {/* Glow */}
              <div className="absolute inset-0 bg-brand-gold/15 blur-2xl rounded-3xl" data-id="element-381"></div>

              <div className="relative bg-brand-green border border-brand-gold/40 rounded-2xl px-6 sm:px-8 py-6 sm:py-7 shadow-[0_20px_50px_-15px_rgba(28,57,40,0.4)] text-center overflow-hidden" data-id="element-382">
                {/* Top gold accent line */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent" data-id="element-383"></div>

                <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-brand-gold/15 border border-brand-gold/40 mb-4" data-id="element-384">
                  <Rocket className="w-6 h-6 sm:w-7 sm:h-7 text-brand-gold" strokeWidth={2} data-id="element-385" />
                </div>

                <p className="font-bold text-lg sm:text-xl md:text-2xl text-white tracking-tight mb-3 leading-snug" data-id="element-386">
                  🚀 EL SIGUIENTE NIVEL DEL{' '}
                  <span className="text-brand-gold" data-id="element-387">ECOMMERCE</span>
                </p>
                <p className="text-sm sm:text-base text-white/75 leading-relaxed max-w-md mx-auto" data-id="element-388">
                  Aprende cómo crear tu propia marca, importar desde China y
                  construir un negocio mucho más grande y escalable.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Section header */}
        <FadeIn delay={0.1} data-id="element-389">
          <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-390">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.1] tracking-tight mb-4" data-id="element-391">
              SISTEMA DE MARCA PRIVADA
              <span className="text-brand-gold align-super text-[0.4em] ml-1" data-id="element-392">
                ™
              </span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-brand-text/75 leading-relaxed" data-id="element-393">
              El siguiente nivel del Ecommerce: aprende a importar desde China,
              encontrar proveedores confiables, crear tu propia marca y vender
              productos en diferentes plataformas online.
            </p>
          </div>
        </FadeIn>

        {/* Product layout */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14" data-id="element-394">
          {/* Image */}
          <div className="flex-1 w-full" data-id="element-395">
            <FadeIn delay={0.1} data-id="element-396">
              <img src="https://cdn.magicpatterns.com/uploads/cSBDejiN45CDRgZdCx7ynL/portada_IMP.png" alt="Sistema de Marca Privada™ - Importa desde China, crea tu marca y vende en cualquier plataforma" loading="lazy" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-397" />
            </FadeIn>
          </div>

          {/* Content */}
          <div className="flex-1 w-full text-center lg:text-left" data-id="element-398">
            <FadeIn delay={0.2} data-id="element-399">
              <p className="text-base sm:text-lg text-brand-text/80 mb-8 leading-relaxed" data-id="element-400">
                Si ya estás aprendiendo a vender online, este sistema te enseña
                cómo ir más allá:{' '}
                <span className="font-semibold text-brand-green" data-id="element-401">
                  crear tu propia marca privada
                </span>
                , buscar productos ganadores, negociar con proveedores,{' '}
                <span className="font-semibold text-brand-green" data-id="element-402">
                  importar desde China
                </span>{' '}
                y construir un negocio más profesional y escalable.
              </p>

              {/* Price block */}
              <div className="mb-6" data-id="element-403">
                <p className="text-base text-brand-text/40 mb-1 lg:text-left text-center" data-id="element-404">
                  ANTES{' '}
                  <span className="line-through font-semibold" data-id="element-405">$97 USD</span>
                </p>
                <p className="text-xs font-semibold uppercase tracking-wider text-brand-text/50 mb-1 lg:text-left text-center" data-id="element-406">
                  🔥 OFERTA DE LANZAMIENTO
                </p>
                <p className="text-5xl md:text-6xl font-bold text-brand-green lg:text-left text-center tracking-tight" data-id="element-407">
                  $36.99{' '}
                  <span className="text-2xl md:text-3xl font-semibold text-brand-text/60" data-id="element-408">
                    USD
                  </span>
                </p>
                <p className="text-xs font-bold text-brand-gold uppercase tracking-wider mt-2 lg:text-left text-center" data-id="element-409">
                  ⚡ Precio especial por tiempo limitado
                </p>
              </div>

              {/* CTA */}
              <Button onClick={goToCheckout} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base md:text-lg font-bold px-10 py-5 shadow-2xl shadow-brand-gold/30 ring-1 ring-brand-gold/40" data-id="element-410">
                🚀 QUIERO CREAR MI MARCA PRIVADA
              </Button>

              {/* Trust badges */}
              <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-3 sm:gap-5 text-brand-text/50 text-xs mt-5" data-id="element-411">
                <span className="flex items-center gap-1.5" data-id="element-412">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-413" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-414">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-415" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-416">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-417" />
                  COMPRA SEGURA
                </span>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}